export const oneDay = 60 * 60 * 24 * 1000;
export const oneYear = oneDay * 365;

export function formatTime(date: number): string {
	function padDigits(digit: number) {
		return digit.toString().length < 2 ? `0${digit}` : digit;
	}

	const hours = padDigits(new Date(date).getHours());
	const minutes = padDigits(new Date(date).getMinutes());

	return `${hours}:${minutes}`;
}

export function convertDateStringToTimestamp(date: string | number): number {
	if (typeof date === 'number') {
		return date;
	}
	return new Date(date).getTime();
}
